import { Button, Flex } from 'antd';
import { useTranslation } from 'react-i18next';

import { Text } from '@shared/ui/antd';

import { getPlans } from '../../lib/constants';
import { formatNumber } from '../../lib/utils';

import styles from './plans-grid.module.scss';

export const PlansGrid = () => {
  const { i18n, t } = useTranslation('translation', { keyPrefix: 'billing' });
  const plans = getPlans(i18n.language);

  return (
    <div className={styles.grid}>
      {plans.map((plan) => (
        <Flex key={plan.credits} className={styles.card} gap={24}>
          <Flex vertical gap={4} align="center">
            <Text variant="md" fontWeight={500} className={styles.credits}>
              {t('plans.creditsLabel', { value: formatNumber(plan.credits) })}
            </Text>

            <Text variant="xs" className={styles.title}>
              {t(plan.titleKey, {
                value: plan.benefit ? formatNumber(plan.benefit) : undefined,
              })}
            </Text>
          </Flex>

          <Flex vertical gap={2} align="center">
            <div className={styles.priceRow}>
              <Text variant="4xl" fontWeight={500} className={styles.price}>
                {plan.pricePerUnit} {t('currency')}
              </Text>
              {plan.oldPricePerUnit && (
                <Text variant="xl" fontWeight={500} className={styles.oldPrice}>
                  {plan.oldPricePerUnit} {t('currency')}
                </Text>
              )}
            </div>

            <Text variant="md" className={styles.unit}>
              {t('plans.unit')}
            </Text>
          </Flex>

          <Button className={styles.button} type="default" size="large" disabled>
            {t('plans.pay')} {formatNumber(plan.total)} {t('currency')}
          </Button>
        </Flex>
      ))}
    </div>
  );
};
